export default __webpack_public_path__ + "static/media/price-high.98e70557.svg";